<app-dropdown-menu
  ariaLabel="Filter states"
  menuClass="stateFilterMenu"
  [revealOnHover]="true"
  [imageIconUrl]="filterIconSrc"
  [dropdownOpenIconWidth]="12"
  [dropdownOpenIconHeight]="12"
  [textIndicator]="(!allSelected ? '('+selectedStates.length+')' : '')"
  [textIndicatorTooltip]="'caseOverview.table.stateFilter.textIndicator.tooltip' | translate:{ visibleNumberOfStates: visibleNumberOfStates, totalNumberOfStates: totalNumberOfStates }"
>
  <div class="stateFilterOption stateFilterAll" (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()">
    <mat-checkbox
      [checked]="allSelected"
      [indeterminate]="someSelected"
      (change)="toggleAll($event.checked)">
    </mat-checkbox>
    <span class="stateFilterLabel">{{ 'caseOverview.table.stateFilter.all' | translate }}</span>
  </div>
  @for (state of states; track state) {
    <div
      class="stateFilterOption"
      (click)="$event.stopPropagation()"
      (keydown.enter)="$event.stopPropagation()"
      (keydown.space)="$event.stopPropagation()"
    >
      <mat-checkbox
        [checked]="isSelected(state)"
        (change)="toggleState(state, $event.checked)">
      </mat-checkbox>
      <span class="documentTagRemake" [ngClass]="state.toLowerCase()">
        {{ 'caseOverview.table.states.' + state.toLowerCase() | translate }}
      </span>
    </div>
  }
</app-dropdown-menu>
